module.exports = __webpack_public_path__ + "img/map-pointer.036ee292.svg";